import { usersSaysLocales } from '@elem/compPage/a-new-era-of-cool/config/pageConfig';
import { useRouter } from 'next/router';

import BannerA from '../components/BannerA';
import FooterTcA from '../components/FooterTcA';
import ListA from '../components/ListA';
import ListB from '../components/ListB';
import SectionA from '../components/SectionA';
import SectionB from '../components/SectionB';

export default function StatusItem() {
    const { locale } = useRouter();
    const isEU = ['eu', 'uk', 'de', 'fr', 'it', 'es'].includes(locale);

    return (
        <>
            <BannerA />
            {!isEU && <SectionA />}
            <ListA />
            <SectionB />
            {!!usersSaysLocales.includes(locale as string) && <ListB />}
            <FooterTcA />
        </>
    );
}
